import client from './client';
import qs from 'qs';

/**
 * 개발/서버정보 - DB설정 리스트
 */
export const dbSettingList = () => client.get(`/api/system/server/db_setting`);

/**
 * 개발/서버정보 - DB설정 게제 수정
 */
export const dbSettingUseYn = (params) =>
  client.post(`/api/system/server/db_setting_useyn`, qs.stringify(params));

/**
 * 개발/서버정보 - DB설정 등록
 */
export const addDbSetting = (params) =>
  client.post(`/api/system/server/db_setting_write`, qs.stringify(params));

/**
 * 개발/서버정보 - DB설정 상세
 */
export const detailDbSetting = (params) =>
  client.get(`/api/system/server/db_setting/detail?` + qs.stringify(params));

/**
 * 개발/서버정보 - DB설정 상세 수정
 */
export const editDbDetail = (params) =>
  client.post(`/api/system/server/db_setting_modify`, qs.stringify(params));

/**
 * 개발/서버정보 - DB설정 세부정보
 */
export const deDetailList = (params) =>
  client.get(`/api/system/server/db_detail`, params);

/**
 * 개발/서버정보 - DB설정 등록
 */
export const addDeDetail = (params) =>
  client.post(`/api/system/server/db_detail_write`, qs.stringify(params));

/**
 * 개발/서버정보 - DB설정 세부정보 사용여부 수정
 */
export const deDetailUseYn = (params) =>
  client.post(`/api/system/server/db_detail_useyn`, qs.stringify(params));

/**
 * 개발/서버정보 - DB설정 세부정보 사용여부 수정
 */
export const deDetailEdit = (params) =>
  client.post(`/api/system/server/db_detail_modify`, params);

/**
 * 개발/서버정보 - DB설정 세부정보 상세
 */
export const detailDbSettingDetail = (params) =>
  client.get(`/api/system/server/db_detail/detail?` + qs.stringify(params));

/**
 * 개발/서버정보 - DB설정 리스트 - 삭제
 */
export const dbSettingListDelete = (params) =>
  client.delete(`/api//system/server/db_setting_del`, {
    data: { ...params },
  });

/**
 * 개발/서버정보 - DB설정 세부상세 - 삭제
 */
export const dbSettingDetailDelete = (params) =>
  client.delete(`/api/system/server/db_detail_del`, {
    data: { ...params },
  });

// /**
//  * 개발/서버정보 - IP차단관리 리스트
//  */
// export const IpBlockList = (params) =>
//   client.get(`/api/system/server/ip_block`, params);

/**
 * 모비온 공통 어뷰징관리 카테고리 구분코드
 */
export const IpBlocKAbsgCtgrTpCode = () =>
  client.get(`/api/code/absgCtgrTpCode`);

/**
 * 광고주전용 - IP차단관리 리스트
 */
export const IpBlockList = (props) => client.get(`/api/adver/ip_block`, props);

/**
 * 개발/서버정보 - IP차단관리 리스트
 */
export const IpBlockListDetail = (params) =>
  client.get(`/api/adver/ip_block/detail`, { params: params });

/**
 * 개발/서버정보 - IP차단관리 등록
 */
export const addIpBlock = (params) =>
  client.post(`/api/adver/ip_regist`, params);

/**
 * 광고주전용 - IP차단관리 다중등록
 */
export const addMultiIpBlock = (params) =>
  client.post(`/api/adver/ip_block/upload`, qs.stringify(params));

/**
 * 광고주전용 - IP차단관리 해제
 */
export const ipUnBlock = (props) => client.post(`/api/adver/block_del`, props);

/**
 * 개발/서버정보 - DB설정 리스트
 */
export const CodeDbList = (params) =>
  client.get(`/api/system/server/code_setting`, params);

/**
 * 개발/서버정보 - DB파티션정보
 */
export const DbPattionList = (params) =>
  client.get(`/api/system/server/db_partition`, params);

/*
 * 개발/서버정보 - DB설정 리스트
 */
export const CodeTpListCode = (params) =>
  client.get(`/api/code/mobonTpList`, params);

/*
 * 개발/서버정보 - 요청수 URL 리스트
 */
export const reqUrlList = (props) =>
  client.get(`/api/system/server/req_setting`, props);

/**
 * 개발/서버정보 - 요청수 URL 리스트 수정
 */
export const reqUrlModify = (params) =>
  client.post(`/api/system/server/req_modify?` + qs.stringify(params));

export const productCode = (props) => client.get(`/api/code/product`, props);

export const svcTpCode = (props) => client.get(`/api/code/svcTpCode`, props);
